//@ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InputForm, { AutoCompleteValue } from "../../../Components/InputForm/InputForm";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";
import { APICall } from "../../../Helpers/Network/APICalls";
import { useLocation } from "react-router-dom";
import { LoaderContext } from "../../../Helpers/Context/Context";
import moment from "moment";
import notify from "../../../Helpers/ToastNotification";
import "./SectorMaster.css";
import { insertUpdateSectorData, getSectorDataById } from "../../../Helpers/APIEndPoints/EndPoints";
import { useSelector } from "react-redux";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";

const SectorMasterEdit = () => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [sector, setSector] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [editMode, setEditMode] = useState(false);
  // submit validation
  const context = useSelector((state: any) => state.updateReduxStore);
 
  const [formErrors, setFormErrors] = useState({});
  const [code, setCode] = useState("");
  let formErrorObj = {};

  useEffect(() => {
    (async () => {
      showLoader();
      setEditMode(true);
      if (state !== null && state.id && state.id > 0) {
        await getSectorDataByIdF();
      }
      hideLoader();
    })();
  }, []);

  const getSectorDataByIdF = async () => {
    let obj = {
      Id: state.id,
    };
    const resp = await APICall(getSectorDataById, obj);
    if (resp?.Data?.Data?.length > 0) {
      setEditMode(false);
      setSector(resp.Data.Data[0].Name);
      setCode(resp.Data.Data[0].Code);
      setIsActive(resp.Data.Data[0].IsActive);
    }
  };

  const onSubmitValidation = () => {
    setFormErrors({});
    formErrorObj = {};
    if (!sector || sector === "") {
      formErrorObj["Sector_isEmpty"] = "Sector can not be empty";
    }
    if (sector.length > 200) {
      formErrorObj["Sector_isEmpty"] = "Sector name must be less than 200 characters";
    }
    if (!code || code === "") {
      formErrorObj["Code_isEmpty"] = "Code can not be empty";
    }
    setFormErrors(formErrorObj);
  };

  const onClickFunction = async (action: any) => {
    showLoader();
    if (action === "Submit") {
      await onSubmitValidation();
      let isEmpty = Object.values(formErrorObj).every((f) => {
        return f === "" || f === null || f === undefined;
      });
      if (isEmpty === true) {
        let param = {
          Id: state.id != null || state.id != 0 ? state.id : 0,
          Name: sector,
          Code: code,
          IsActive: isActive ? 1 : 0,
          UserId: context.Id,
          CreatedBy: context.Id,
          CreatedDateUtc: moment(new Date()).format(moment.HTML5_FMT.DATETIME_LOCAL),
        };

        const insertData = await APICall(insertUpdateSectorData, param);

        if (insertData?.Data?.Status == ApiStatus.Error) {
          const errors = insertData?.Data?.Data;
          const errorComponent = Array.isArray(errors) ? <div dangerouslySetInnerHTML={{ __html: errors?.join("<br />") }} /> : errors;
          notify(1, errorComponent);
        } else if (insertData?.Status == ApiStatus.Error) {
          notify(1, insertData?.Data);
        } else if (insertData?.Data != null) {
          if (state !== null && state.id && state.id > 0) {
            notify(0, "Sector successfully updated");
          } else {
            notify(0, "Sector successfully inserted");
          }
          navigate(-1);
        }
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      navigate(-1);
    }
    hideLoader();
  };

  const handleKeyNumbers = (event) => {
    // Prevent numeric character input
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      event.preventDefault();
    }
  };

  const handleTextEvent = async (event: any, field: any) => {
    let value = event.target.value;
    // const regex = /^[0-9]+$/;
    if (field === "sector") {
      setSector(value);
    }

    if (field === "code") {
      // if (value === "" || regex.test(value)) {
      if (value.length > 10) {
        value = value.slice(0, 10);
      }
      setCode(value);
      // }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    formErrorObj = {};
    setSector("");
    setCode("");
  };

  return (
    <>
      <div>
        <div className="">
          <div className="col-lg-12 col-md-12 p-0">
            <div className="row">
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Sector</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  placeholder={""}
                  value={sector}
                  onChange={(e) => handleTextEvent(e, "sector")}
                  textArea={false}
                  onKeyPress={handleKeyNumbers}
                />
                <p style={{ color: "red" }}>{formErrors["Sector_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Code</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  placeholder={""}
                  value={code}
                  onChange={(e) => handleTextEvent(e, "code")}
                  onKeyPress={(e) => handleKeyPress(e)}
                  textArea={false}
                />
                <p style={{ color: "red" }}>{formErrors["Code_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
                <div className="form-group">
                  <label className="col-form-label">Active Status</label>
                  <sup>*</sup>
                  <div className="custom-checkbox">
                    <input
                      autoComplete={AutoCompleteValue}
                      disabled={editMode ? true : false}
                      type="checkbox"
                      onChange={(e) => setIsActive(e.target.checked)}
                      name="isActive"
                      checked={isActive}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3">
          <div>
            <ButtonForm className="btn btn-submit" style={{ marginLeft: 5 }} id="submit" value={<p><i className="fas fa-paper-plane"></i> Submit</p> } onClick={() => onClickFunction("Submit")} />
          </div>
          {state !== null && state.id && state.id > 0 ? (
            ""
          ) : (
            <div>
              <ButtonForm className="btn btn-info" id="Reset" style={{ marginLeft: 5 }} value={<p><i className="fas fa-undo"></i> Reset</p> } onClick={() => onClickFunction("Reset")} />
            </div>
          )}
          <div>
            <ButtonForm className="btn btn-cancel" id="cancel" style={{ marginLeft: 5 }} value={<p><i className="far fa-times-circle"></i> Cancel</p> } onClick={() => navigate("/master/SectorMaster")} />
          </div>
        </div>
      </div>
    </>
  );
};

export default SectorMasterEdit;
